import * as React from 'react';

const LogoAccessApp = (props) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={109} height={110} viewBox='0 0 109 110' fill='none' {...props}>
		<g filter='url(#a)'>
			<path fill='#001F97' d='M4 10.5a8 8 0 0 1 8-8h85a8 8 0 0 1 8 8v85a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8v-85Z' />
			<rect width={60.189} height={13.273} x={25} y={20.5} fill='#fff' rx={4} />
			<rect width={18.895} height={13.273} x={66.293} y={37.739} fill='#fff' rx={4} />
			<rect width={37.975} height={13.273} x={47.222} y={54.977} fill='#fff' rx={4} />
			<rect width={60.189} height={13.273} x={25} y={72.206} fill='#fff' rx={4} />
		</g>
		<defs>
			<filter
				id='a'
				width={109}
				height={109}
				x={0}
				y={0.5}
				colorInterpolationFilters='sRGB'
				filterUnits='userSpaceOnUse'
			>
				<feFlood floodOpacity={0} result='BackgroundImageFix' />
				<feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
				<feOffset dy={2} />
				<feGaussianBlur stdDeviation={2} />
				<feComposite in2='hardAlpha' operator='out' />
				<feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
				<feBlend in2='BackgroundImageFix' result='effect1_dropShadow_731_216' />
				<feBlend in='SourceGraphic' in2='effect1_dropShadow_731_216' result='shape' />
			</filter>
		</defs>
	</svg>
);
export default LogoAccessApp;
